import { Menu, X } from 'lucide-react'
import { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from '@/hooks/useTranslation'

export function MobileNavbar({ children }: { children: ReactNode }) {
	const [isOpen, setIsOpen] = useState(false)
	const { i18n } = useTranslation()
	const fr = i18n.language?.startsWith('fr')

	useEffect(() => {
		const closeHamburgerNavigation = () => setIsOpen(false)
		const onKeyDown = (event: KeyboardEvent) => {
			if (event.key === 'Escape') setIsOpen(false)
		}
		window.addEventListener('keydown', onKeyDown)
		window.addEventListener('orientationchange', closeHamburgerNavigation)
		window.addEventListener('resize', closeHamburgerNavigation)

		return () => {
			window.removeEventListener('keydown', onKeyDown)
			window.removeEventListener('orientationchange', closeHamburgerNavigation)
			window.removeEventListener('resize', closeHamburgerNavigation)
		}
	}, [])

	return (
		<>
			<button type="button" className="flex size-11 items-center justify-center lg:hidden" aria-expanded={isOpen} aria-label={isOpen ? (fr ? 'Fermer le menu' : 'Close navigation menu') : (fr ? 'Ouvrir le menu' : 'Open navigation menu')} onClick={() => setIsOpen(!isOpen)}>
				{isOpen ? <X /> : <Menu />}
			</button>
			{isOpen && (
				<div
					className="absolute inset-x-0 top-full z-40 max-h-[calc(100dvh-80px)] overflow-auto bg-white shadow-sm lg:hidden"
					onClick={() => setIsOpen(false)}>
					{children}
				</div>
			)}
		</>
	)
}
